import request from '@/utils/request'

let CourseApi = {

  /*课程列表*/
  list(data) {
    return request._post('/shop/plus.course.Index/index', data);
},
listx(data) {
    return request._post('/shop/plus.course.Index/indexx', data);
},
/*添加课程*/
add(data) {
    return request._post('/shop/plus.course.Index/add', data);
},
/*修改课程*/
edit(data) {
    return request._post('/shop/plus.course.Index/edit', data);
},
/*删除课程*/
del(data) {
    return request._post('/shop/plus.course.Index/del', data);
},
/*课程详情*/
detail(data) {
  return request._post('/shop/plus.course.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.course.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.course.Setting/getSetting', data, errorback);
    },
}
export default CourseApi;



// WEBPACK FOOTER //
// ./src/api/course.js